import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { withRouter } from 'react-router-dom'

import { showMoreThreshold } from './utils'
import { makeLink } from '../../../../common/utils/urlHelper'
import MultiSelectPanelFooter from './multiSelectPanelFooter'
import MultiSelectPanelBody from './multiSelectPanelBody'
import CloseIcon from '../../icons/close'

class FiltersMultiSelectPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false,
      selectedOption: props.parsedLocation[props.type] || ''
    }

    this.onToggleOption = this.onToggleOption.bind(this)
    this.onUpdateOption = this.onUpdateOption.bind(this)
    this.onSelectOption = this.onSelectOption.bind(this)
  }

  onToggleOption(event) {
    event.preventDefault()
    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }

  onSelectOption(option) {
    const { selectedOption } = this.state
    const selectedOptionArray =
      selectedOption !== '' ? selectedOption.split(',') : []
    if (selectedOptionArray.indexOf(option) >= 0) {
      this.setState({
        selectedOption: selectedOptionArray
          .filter(opts => {
            return opts !== option
          })
          .join(',')
      })
    } else {
      this.setState({
        selectedOption: [...selectedOptionArray, option].join(',')
      })
    }
  }

  onUpdateOption() {
    const { selectedOption } = this.state
    const { parsedLocation, history, type } = this.props

    let newQuery = Object.assign({}, parsedLocation)
    newQuery[type] = selectedOption

    // reset page param
    delete newQuery.page

    history.push(makeLink(newQuery))
  }

  render() {
    const { isExpanded, selectedOption } = this.state
    const { items, showPanel, togglePanel, parsedLocation, type } = this.props
    const isExpandable = items.length > showMoreThreshold[type]

    const panelBodyClassNames = classNames('search-facet-panel__body', {
      'is-active': showPanel
    })

    return (
      <div className={panelBodyClassNames}>
        <div className="search-facet-panel__body-inner">
          <button
            className="search-facet-panel__body-close fds-c-button"
            onClick={togglePanel}
          >
            <CloseIcon />
          </button>

          <MultiSelectPanelBody
            isExpandable={isExpandable}
            isExpanded={isExpanded}
            onSelectOption={this.onSelectOption}
            parsedLocation={parsedLocation}
            selectedOption={selectedOption}
            items={items}
            type={type}
          />

          <MultiSelectPanelFooter
            isExpandable={isExpandable}
            isExpanded={isExpanded}
            moreOptionCount={items.length - showMoreThreshold[type]}
            onToggleOption={this.onToggleOption}
            togglePanel={togglePanel}
            onUpdateOption={this.onUpdateOption}
          />
        </div>
      </div>
    )
  }
}

FiltersMultiSelectPanel.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  parsedLocation: PropTypes.object.isRequired,
  showPanel: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired
}

export default withRouter(FiltersMultiSelectPanel)



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/multiSelect.js